<div class="login-page">
  <!-- Left: form -->
  <div class="login-panel">
    <div class="login-panel-inner">
      <div class="login-logo">
        <img alt="Snöball" src="../../../assets/images/blue-logo.png" />
      </div>

      <h1 class="login-welcome">{{ 'Loginpage.forgot_heading' | translate }}</h1>
      <p class="login-lead">{{ 'Loginpage.forgot_lead' | translate }}</p>

      <!--
        The server answers every request the same way, so neither block can be
        read as "this address does or does not have an account". Show whatever it
        said rather than a message of our own.
      -->
      @if (submitted && !passMessage()['success'] && responseMessage) {
      <div
        class="login-alert login-alert--error"
        role="alert"
      >
        <p>{{ responseMessage }}</p>
      </div>
      }
      @if (submitted && passMessage()['success'] && responseMessage) {
      <div
        class="login-alert login-alert--success"
        role="status"
        aria-live="polite"
      >
        <p>{{ responseMessage }}</p>
      </div>
      }

      <form (ngSubmit)="onSubmit()" [formGroup]="passwordForm" class="login-form">
        <label class="login-field-label" for="forgot-email">{{ 'Loginpage.email' | translate }}</label>
        <input
          id="forgot-email"
          class="login-input"
          [class.login-input--invalid]="submitted && f.email.errors"
          formControlName="email"
          [placeholder]="'Loginpage.email_placeholder' | translate"
          type="email"
          autocomplete="username"
          required="required"
        />
        @if (submitted && f.email.errors) {
        <div class="login-field-error">
          @if (f.email.errors.required) {
          <span>{{ 'Loginpage.email_require' | translate }}</span>
          }
          @if (f.email.errors.email) {
          <span>{{ 'Loginpage.valid_email' | translate }}</span>
          }
        </div>
        }

        <button class="login-submit mt-3" type="submit" [disabled]="sendPending()"
                [attr.aria-busy]="sendPending()">
          @if (sendPending()) {
          <i class="fa fa-spinner fa-spin me-2" aria-hidden="true"></i>
          }
          @if (sendPending()) {
          <span>{{ 'Loginpage.sending' | translate }}</span>
          }
          @if (!sendPending()) {
          <span>{{ 'Loginpage.send_reset_link' | translate }}</span>
          }
        </button>
      </form>

      <p class="login-footer-cta">
        <a class="login-forgot" routerLink="/login">
          <span aria-hidden="true">←</span> {{ 'Loginpage.back_to_signin' | translate }}
        </a>
      </p>
    </div>
  </div>

  <!-- Right: marketing (desktop) -->
  <app-auth-marketing-panel></app-auth-marketing-panel>
</div>
